module.exports = __webpack_public_path__ + "static/media/GM.a382c494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GM.svg
// module id = 262
// module chunks = 0